document.addEventListener('DOMContentLoaded', (e) => {
    const mainFilterCollection = document.querySelector('#main-collection-filters');
    const btnCloseFilter = document.querySelector('.button-close__filter');
    const btnOpenFilter = document.querySelector('.button-open__filter');
    const applyBtn = document.querySelector('.apply-filter');
    const overlayWrapper = document.createElement('div');

    // Filter logic
    [btnCloseFilter, btnOpenFilter, overlayWrapper, applyBtn].forEach(btn => {
        btn.addEventListener('click' , (e) => {
            console.log(e)
            const btnOpen = btn.classList.contains('button-open__filter');
            const btnClose = btn.classList.contains('button-close__filter');

            function closeFilterHandler(){
                mainFilterCollection.classList.remove('open-filter');
                overlayWrapper?.remove();
            }

            if (btnOpen) {
                if(!mainFilterCollection.classList.contains('open-filter')){
                    mainFilterCollection.classList.add('open-filter');
                    document.body.prepend(overlayWrapper);
                    overlayWrapper.classList.add('overlay-filter');
                }
            }else if(btnClose){
                closeFilterHandler()
            }else if(overlayWrapper){
                closeFilterHandler()
            }else if(applyBtn){
                closeFilterHandler()
            }
        });
     });
});